/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 30/6/21.
 */

import axios from "axios";
import * as _ from "lodash";
import store from "@/store";
import config from "@/config"

export default {
	get(assetId) {
		return axios.get(
			`${config.ZETTA_URL}/asset/${assetId}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		);
	},

	delete(assetId) {
		return axios.delete(
			`${config.ZETTA_URL}/asset/${assetId}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	},

	updateAsset({AssetID, ...payload}) {
		return axios.patch(
			`${config.ZETTA_URL}/asset/${AssetID}`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	list(assets, station_id) {
		return axios.post(config.ZETTA_URL + "/asset/list", assets, {
			params: {
				"includeStationAssets": true,
				"stationID": station_id
			},
			headers: {
				"Authorization": store.getters.getAccessToken(),
				"Z-Cloud-Org-Id": store.getters.getOrgID()
			}
		});
	},

	getTypes() {
		let orgID = store.getters.getOrgID();
		return axios.get(
			`${config.ZETTA_URL}/asset/type/byorganization/${orgID}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": orgID
				}
			}
		);
	},

	textSearch(params) {
		let url = `${config.ZETTA_URL}/asset/textSearch`

		let payload = {
			SortField: "Score",
			SortOrder: "desc",
			SearchString: params.searchField,
			PageSize: 100,
			SearchType: 255
		};

		if (params.assetTypeID) {
			payload.IncludeAssetTypes = [params.assetTypeID]
		}

		return axios.post(
			url,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		);
	},

	stationsGraphql(params) {
		let filter = params.filter ? params.filter.replace(/"([^(")"]+)":/g, "$1:") : "";

		let url = `${config.ZETTA_URL}/asset-station/graphql/${params.stationID}`
		if (params.assetTypeID) {
			url += `?AssetTypeID=${params.assetTypeID}`
		}

		let sort = params.sortOrder;
		if (params.sortField.includes(".")) {
			const fields = params.sortField.split(".");
			while (fields.length > 0) {
				sort = `{${fields.splice(-1)}: ${sort}}`;
			}
		}
		else {
			sort = `{${params.sortField}: ${sort}}`;
		}

		return axios.post(
			url,
			{
				query: `{
						stationassets(
							pagination: {limit: ${params.limit}, skip: ${params.skip}},
							sort: ${sort}
							${params.filter ? `,filter: ${filter}` : ""}
						),
							{${this.getNestedKeys(this.assetProperties())}}
						}`.replace(/\s/g, '')
			}, {
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		);
	},

	assetAllStations(AssetID) {
		return axios.get(
			`${config.ZETTA_URL}/asset-station/list/allstations/${AssetID}`, {
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			})
	},

	getStationAsset(payload) {
		return axios.get(
			`${config.ZETTA_URL}/asset-station/${payload.StationID}/${payload.AssetID}`, {
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			})
	},

	updateAssetStations(AssetID, payload) {
		return axios.post(
			`${config.ZETTA_URL}/asset-station/addorupdate`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	},

	updateStationAsset(payload) {
		return axios.patch(
			`${config.ZETTA_URL}/asset-station/${payload.StationID}/${payload.AssetID}`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			});
	},

	assetProperties() {
		return {
			"AssetID": null,
			"OrganizationID": null,
			"AssetTypeID": null,
			"Title": null,
			"Artist": null,
			"Album": null,
			"ISRC": null,
			"ISCI": null,
			"Label": null,
			"Year": null,
			"Tags": ["FILL"],
			"CreatedDateTime": null,
			"ModifiedDateTime": null,
			"POIMarkup": {
				"Path": null,
				"Length": null, 		// in seconds
				"POIMarkers": {
					"POIType": null,
					"Position": null
				}
			},
			"AnalysisData": {
				"LengthInSeconds": null,
				"Intro1": null,
				"Intro2": null
			},
			"Comment": null,
			"ImageUrl": null,
			"CreatedBy": null,
			"ReleaseDateTime": null,	// ISO8601
			"EndDateTime": null,		// ISO8601,
			"ThirdPartyIDs": {
				"MusicPointID": null,
				"ExternalID": null
			},
			"Version": null,
			"isDeleted": null,
			"KillDateTime": null
		};
	},

	getNestedKeys(obj) {
		let array = [];
		Object.keys(obj).forEach((key) => {
			if (_.isObject(obj[key]) && !_.isArray(obj[key])) {
				array.push(`${key}{${this.getNestedKeys(obj[key])}}`);
			}
			else {
				array.push(key);
			}
		});
		return array.join();
	},

	getAudioUrl: function (assetID) {
		return axios.post(
			`${config.ZETTA_URL}/contentmanagement/initializedownload`,
			{
				BucketFilepath: `audio/${assetID}.aac`,
			}, {
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		);
	},

	getPartialAudio: function (assetID, start, end) {
		const form = new FormData();
		form.append("auth-bearer-token", store.getters.getAccessToken());
		return axios.post(`${config.UTIL_URL}/partialaudio/${assetID}/${start}/${end}/AAC`,
			form,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				},
				responseType: "arraybuffer"
			}
		);
	},

	createAsset(payload) {
		return axios.post(
			`${config.ZETTA_URL}/asset`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	},

	importAssetEvent(payload) {
		return axios.post(
			`${config.ZETTA_URL}/import/importassetevent`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	},

	importAsset(payload) {
		return axios.post(
			`${config.ZETTA_URL}/import/importasset`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	},

	getAssetGSelectorCategory(StationID, AssetID) {
		return axios.get(
			`${config.ZETTA_URL}/gselector/asset/category/${StationID}/${AssetID}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	},

	getGSelectorCategoriesList(StationID, AssetTypeID) {
		return axios.get(
			`${config.ZETTA_URL}/gselector/category/list/${StationID}/${AssetTypeID}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	}
}
